import { CreateTRPCReact, createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import type { AppRouter } from '@server'

export const trpc: CreateTRPCReact<AppRouter, unknown> = createTRPCReact<AppRouter>()

export const trpcClient = trpc.createClient({
    links: [
        httpBatchLink({
            url: `https://api.booking.kalialab.de/trpc`,
            headers: () => {
                // Update a dummy localstorage item to ensure localstorage is initialized at this point.
                const now = new Date().getTime();
                localStorage.setItem("dummy", now.toString());

                const token = localStorage.getItem('token');
                return {
                    Authorization: token ? `Bearer ${token}` : '',
                };
            },
        }),
    ],
});